
export const isTestingForMobile = true